<template>
    <CustomReveal
        v-if="user !== null"
        :dusk="'user-modal-' + user.id"
        :isVisible="user !== null"
        revealId="card"
        class="user-modal"
        :class="{'report-menu-open': reportMenuVisible}"
        v-on:close-reveal-card="closeUserModalWithVisit">

        <div class="secondary-menu profile">

            <div class="secondary-menu-body" id="card" data-reveal2>
              <UpgradeToProModal @hideModal="showUpgradeModal = false" v-if="showUpgradeModal"></UpgradeToProModal>
              <UpgradeToProVisitModal @hideModal="showUpgradeVisitModal = false" v-if="showUpgradeVisitModal"></UpgradeToProVisitModal>
                <div class="secondary-menu-header">
                    <i class="back" @click="closeUserModalWithVisit"></i>
                    <div @click="copyHandle" class="info"
                        :class="{'online': user.isOnline,'meet_now':user.meet_now, 'was-online': user.wasRecentlyOnline && !user.isOnline}">
                        <div class="name notranslate">{{ user.headline }}</div>
                        <div class="link-group">
                          <div class="link notranslate" :class="{'verified' : user.verified}">@{{ user.handle }}</div>
                          <div class="verified-icon" v-if="user.verified"></div>
                        </div>
                        <div class="how-far notranslate" v-if="!isSelfUser">{{ getDistanceString(user) }}</div>
                    </div>
                    <alert v-if="link_copied_alert" :small="true" v-on:hide-alert="hideAlert">
                      {{ trans('link_copied') }}
                    </alert>
                  <i class="notes" v-if="!isSelfUser" :class="{'active' : user.note !== null}" @click="toggleNoteModal"></i>
                  <i class="dots" v-if="!isSelfUser && profile.id" @click="menuVisible = !menuVisible"></i>
                  <div class="block-report" :class="{'open': menuVisible}">
                      <div id="block-profile" class="option block"
                          v-show="!reportMenuVisible" v-on:click="blockUser(user.id)">
                          <span>{{ trans('block_user') }}</span>
                      </div>
                      <div id="report-profile" class="option report"
                          v-show="!reportMenuVisible" v-on:click="showReportMenu">
                          <span>{{ trans('report_user') }}</span>
                      </div>
                  </div>
                  <UserNotes v-if="!isSelfUser" @hideModal="showNotesModal = false" :noteString="user.note ? user.note.note : ''" :user_id="user.id" :active="showNotesModal"></UserNotes>
                </div>

                <div class="main-box">
                    <div class="photo" :style="{'background': `url(${this.userPhoto}) no-repeat center / cover`}"
                        @click="displayUserPhoto(user.public_photos[0])">
                    </div>

                    <div class="main-box-footer" :class="{'justify-end': discreetMode}">
                        <!-- <router-link v-if="isSelfUser" class="edit-button btn" :to="`/profile/edit`">
                            <span>{{ 'Edit' || trans('edit_profile') }}</span>
                        </router-link> -->
                      <div class="hide-visit-button" @click="toggleHideVisit" :class="{'active' : hideVisitButtonActive}" v-if="!isSelfUser && !discreetMode"></div>

                      <div class="func-buttons" v-if="!isSelfUser">
                            <div id="to-favorite" class="button to-favorite"
                                v-on:click="toggleFavorite(user)"
                                :class="{'selected': user.isFavorite}">
                            </div>
                            <div id="to-tap" class="button to-tap" :class="{'tapsForPro': userIsPro, 'open': toggleTapVisible}" v-on:click="toggleTapVisible">
                                <div v-if="waveIcon" class="tap-icon-given" :style="{'background-image': 'url('+ waveIcon +')'}"></div>
                                <div v-else class="to-tap-icon"></div>
                                <transition name="scale-in-center">
                                    <div class="taps" v-show="tapsVisible">
<!--                                        <div class="tap video" v-if="userIsPro"-->
<!--                                            v-on:click="waveToUser(userId, 'video', $event)">-->
<!--                                        </div>-->

                                      <div class="tap donut" v-if="userIsPro"
                                           v-on:click="waveToUser(userId, 'donut', $event)">
                                      </div>

                                        <div class="tap rocket" v-if="userIsPro"
                                            v-on:click="waveToUser(userId, 'rocket', $event)">
                                        </div>
                                        <div class="tap beer" v-if="userIsPro"
                                            v-on:click="waveToUser(userId, 'beer', $event)">
                                        </div>
<!--                                        <div class="tap ring" v-if="userIsPro"-->
<!--                                            v-on:click="waveToUser(userId, 'ring', $event)">-->
<!--                                        </div>-->
                                      <div class="tap nicebody" v-if="userIsPro"
                                           v-on:click="waveToUser(userId, 'nicebody', $event)">
                                      </div>
                                        <div class="tap now" v-on:click="waveToUser(userId, 'now', $event)"></div>
                                      <div class="tap pig" v-on:click="waveToUser(userId, 'pig', $event)"></div>
<!--                                        <div class="tap sweat" v-on:click="waveToUser(userId, 'sweat', $event)"></div>-->
                                        <div class="tap devil" v-on:click="waveToUser(userId, 'devil', $event)"></div>
                                        <div class="tap apple" v-on:click="waveToUser(userId, 'apple', $event)"></div>
                                        <div class="tap love" v-on:click="waveToUser(userId, 'love', $event)"></div>
                                        <div class="tap banana" v-on:click="waveToUser(userId, 'banana', $event)"></div>
                                        <div class="tap fire" v-on:click="waveToUser(userId, 'fire', $event)"></div>
                                        <div class="tap hand" v-on:click="waveToUser(userId, 'hand', $event)"></div>
                                    </div>
                                </transition>
                            </div>
                            <div id="to-chat" class="button to-chat"
                                v-on:click="startUserConversation(user.id, true)"
                                :class="{'notificated': user.unreadMessagesCount > 0}">
                            </div>
                        </div>
                    </div>
                </div>
                <vue-custom-scrollbar class="profile-footer" v-if="user.about || user.height || user.weight || user.body || user.position || user.penis || user.hiv || user.drugs || notDefaultPublicPhotos && notDefaultPublicPhotos.length || user && user.public_videos.length">
                    <div class="box">
                        <div @click="clickAbout" class="about" v-if="user.about">
                            <p v-html="getMsgTextWithLinks(user.about,user.about_links)"></p>
                        </div>
                        <div class="tags" v-if="!isApp && user.tags && user.tags.length">
                            <div class="tag notranslate" v-for="tag in user.tags"><a @click.prevent="goSearchTag(tag);" :href="'/search?q='+encodeURIComponent('#'+tag.name)">{{ tag.name }}</a></div>
                        </div>
                        <div class="parameters-box" v-if="user.age || user.height || user.weight || user.body || user.position || user.penis || user.hiv || user.drugs">
                            <div class="parameters" v-if="user.age || user.height || user.weight || user.body">
                                <span v-if="user.age">{{ user.age }}</span>
                                <span v-if="user.height">{{ formatHeight(user.height) }}</span>
                                <span v-if="user.weight">{{ formatWeight(user.weight) }}</span>
                                <span v-if="user.body">{{ transBody(user.body).toLowerCase() }}</span>
                            </div>
                            <div class="parameters" v-if="user.position || user.penis">
                                <span v-if="user.position">{{ transPosition(user.position).toLowerCase() }}</span>
                                <span v-if="user.penis">{{ user.penis }}</span>
                            </div>
                            <div class="parameters" v-if="user.hiv">
                                <span>{{ trans('hiv') }}: {{ transHiv(user.hiv).toLowerCase() }}</span>
                            </div>
                            <div class="parameters" v-if="user.drugs">
                                <span>{{ trans('drugs') }}: {{ transDrugs(user.drugs).toLowerCase() }}</span>
                            </div>
                        </div>
                      <div v-if="user.tiktok_link || user.x_link || user.instagram_link || user.jff_link || buddyLinksReverse.length > 0" class="follow-links">
                        <div class="follow-links-social">
                          <div class="follow-links-social-headline">{{ trans('follow') }}:</div>
                          <div class="follow-links-social-list">
                            <a target="_blank" :href="user[social_link]" v-if="user[social_link]" v-for="social_link in ['jff_link','instagram_link','x_link','tiktok_link']" class="follow-links-social-list-row">
                              <span :class="'follow-links-social-list-row-' + social_link"></span>
                            </a>
                          </div>
                        </div>
                        <div class="follow-links-buddy_links box buddy-links" v-if="buddyLinksReverse.length > 0">
                          <div class="buddy-links-list">
                            <div class="buddy-links-list-row" v-for="buddy_link in buddyLinksReverse">
                              <div class="buddy-links-list-row-img" @click="clickBuddyLink" :data-issue-type="buddy_link.event_type" :data-issue="buddy_link.issue_type" :data-issue-id="buddy_link.issue_id" :style="{'background-image':'url('+buddy_link.photo_small+')'}"></div>
                              <div :data-issue-type="buddy_link.event_type" :data-issue="buddy_link.issue_type" :data-issue-id="buddy_link.issue_id" class="buddy-links-list-row-details"  @click="clickBuddyLink">
                                <div :data-issue-type="buddy_link.event_type" :data-issue="buddy_link.issue_type" :data-issue-id="buddy_link.issue_id" class="buddy-links-list-row-details-headline">{{buddy_link.headline}}</div>
                                <div :data-issue-type="buddy_link.event_type" :data-issue="buddy_link.issue_type" :data-issue-id="buddy_link.issue_id" class="buddy-links-list-row-details-handle">@{{buddy_link.handle}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                </vue-custom-scrollbar>
                <div class="media-list" v-if="notDefaultPublicPhotos && notDefaultPublicPhotos.length || user && user.public_videos.length">
                    <vue-horizontal
                        :button="notDefaultPublicPhotos.length > 4"
                        ref="photo-catalog"
                        class="pics-catalog"
                        v-if="notDefaultPublicPhotos.length > 0">
                        <div class="pic" v-for="photo in notDefaultPublicPhotos"
                             :class="{'sensitive': photo.manual_rating === 'prohibited'}"
                             :id="'photo' + photo.id"
                             @click="displayUserPhoto(photo)"
                        >
                            <div class="img" :id="'photo' + photo.id"
                                :style="{'background': `url(${photo.photo_small}) no-repeat center / cover`}">
                            </div>
                        </div>
                    </vue-horizontal>

                    <vue-horizontal
                        :button="user.public_videos.length > 4"
                        ref="video-catalog"
                        class="pics-catalog"
                        v-if="user.public_videos.length > 0">
                        <div v-for="video in user.public_videos"
                             class="pic video"
                             :id="'video' + video.id"
                             @click="displayUserVideo(video)"
                        >
                            <div class="img" :id="'video' + video.id"
                                :style="{'background': `url(${video.thumb_small}) center / cover`}">
                            </div>
                        </div>
                    </vue-horizontal>
                </div>
            </div>
        </div>

        <UserPhotosReveals v-if="user" :photos="user.public_photos"></UserPhotosReveals>
        <UserVideosReveals v-if="user" :videos="user.public_videos"></UserVideosReveals>

        <div class="mobileSidebarHolder positionLeft forDesktop"
             v-show="showReportMenu"
             :class="{'active': reportMenuVisible}">
            <div class="mobileSidebarHide" @click="hideReportMenu"></div>
            <div class="mobileSidebar">

                <div class="report-menu">
                    <div class="inner">
                        <i class="back" @click="hideReportMenu"></i>
                        <div class="title">{{ trans('report_user') }}</div>
                        <div class="box">
                            <div class="checkbox-container">
                                <label class="checkbox-label">
                                    <input type="checkbox" name="spam" value="spam" v-model="reportData">
                                    <span class="checkbox-custom"></span>
                                    <div class="input-title">{{ trans('report_spam') }}</div>
                                </label>
                            </div>
                            <div class="checkbox-container">
                                <label class="checkbox-label">
                                    <input type="checkbox" name="fake" value="fake" v-model="reportData">
                                    <span class="checkbox-custom"></span>
                                    <div class="input-title">{{ trans('report_fake') }}</div>
                                </label>
                            </div>
                            <div class="checkbox-container">
                                <label class="checkbox-label">
                                    <input type="checkbox" name="harassment" value="harassment" v-model="reportData">
                                    <span class="checkbox-custom"></span>
                                    <div class="input-title">{{ trans('report_harassment') }}</div>
                                </label>
                            </div>
                            <div class="checkbox-container">
                                <label class="checkbox-label">
                                    <input type="checkbox" name="under-age" value="under_age" v-model="reportData">
                                    <span class="checkbox-custom"></span>
                                    <div class="input-title">{{ trans('report_under_age') }}</div>
                                </label>
                            </div>
                            <div class="checkbox-container">
                                <label class="checkbox-label">
                                    <input type="checkbox" name="other" value="other" v-model="reportData">
                                    <span class="checkbox-custom"></span>
                                    <div class="input-title">{{ trans('report_other') }}</div>
                                </label>
                            </div>
                        </div>
                        <button type="send" class="btn" @click="reportUser">{{ trans('send') }}</button>
                    </div>
                </div><!--report-menu-->

            </div>
        </div>

    </CustomReveal>
</template>

<script>
    import {mapState, mapGetters} from 'vuex';

    import CustomReveal from '@buddy/views/widgets/CustomReveal.vue';
    import UserPhotosReveals from '@buddy/views/widgets/UserPhotosReveals.vue';
    import UserVideosReveals from '@buddy/views/widgets/UserVideosReveals.vue';

    import chatModule from '@chat/module/store/type'
    import discoverModule from "@discover/module/store/type";
    import Alert from '@buddy/views/widgets/Alert.vue';

    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import auth from '@general/lib/auth';
    // Vue horizontal for media block
    import VueHorizontal from 'vue-horizontal';
    import UserNotes from "../widgets/UserNotes.vue";
    import notificationsModule from "@notifications/module/store/type";
    import UpgradeToProModal from "../widgets/UpgradeToProModal.vue";
    import UpgradeToProVisitModal from "../widgets/UpgradeToProVisitModal.vue";

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-tap').default,
            require('@general/lib/mixin-chat').default,
            require('@general/lib/mixin-clubs').default,
            require('@general/lib/mixin-events').default,
        ],
        data() {
            return {
                link_copied_alert: false,
                userPhoto: '',
                tapsVisible: false,
                hideVisitButtonActive : false,
                showUpgradeModal : false,
                showUpgradeVisitModal: false,
                menuVisible: false,
                showNotesModal:false,
                reportMenuVisible: false,
                reportData: [],
            }
        },

        created() {
          const onEscape = (e) => {
            if (this.user && e.keyCode === 27) {
              this.closeUserModalWithVisit()
            }
          }
          if(this.isDesktop){
            document.addEventListener('keydown', onEscape)
          }
        },
        components: {
          Alert,
          UpgradeToProVisitModal,
          UpgradeToProModal,
          UserNotes,
            CustomReveal,
            UserPhotosReveals,
            UserVideosReveals,
            vueCustomScrollbar,
            VueHorizontal,
        },
        computed: {
            ...mapState({
                user: state => state.modal.user,
                userIsPro: 'userIsPro',
                blockedUsersIds: 'blockedUsersIds',
                discreetMode: 'discreetMode',
            }),
            ...mapGetters({
                unreadMessagesCount: chatModule.getters.messages.count.unread,
            }),
            buddyLinksReverse(){
              return [].concat(this.user.buddy_links).reverse();
            },
            userId() {
                return this.user.id;
            },
            photos() {
                return this.user && this.user.public_photos;
            },
            photo() {
                return this.publicPhotos && this.publicPhotos.find(el => el.id == this.pid);
            },
            onlyPublicPhotos() {
                return this.photos.filter(v => v.is_default == 'no');
            },
            notDefaultPublicPhotos() {
                return this.user && this.user.public_photos.filter(v => v.photo_orig != this.user.photo_orig)
            }
        },
        methods: {
            copyHandle(){
              this.link_copied_alert = true
              navigator.clipboard.writeText('@' + this.user.handle).then(function() {
                console.log('Async: Copying to clipboard was successful!');
              }, function(err) {
                console.error('Async: Could not copy text: ', err);
              });
            },
            hideAlert(){
              this.link_copied_alert = false;
            },
            toggleHideVisit(){
              if(this.showJoinModalIfNeed()){
                return false;
              }
              if(this.userIsPro){
                this.hideVisitButtonActive = !this.hideVisitButtonActive
              }else{
                this.showUpgradeVisitModal = true;
              }
            },
            clickAbout(e){
              if(e.target.classList.contains('issue_link')){
                this.openLink(e);
              }
            },
            toggleNoteModal(){
              if(this.showJoinModalIfNeed()){
                return false;
              }
              if(this.userIsPro){
                this.showNotesModal = !this.showNotesModal;
              }else{
                this.showUpgradeModal = true;
              }
            },
            closeUserModalWithVisit(){
              if(!this.hideVisitButtonActive){
                this.$store.dispatch(notificationsModule.actions.addVisit, { userId: this.user.id });
              }
              this.hideVisitButtonActive = false;
              this.showNotesModal = false;
              let self = this;
              setTimeout(function (){
                self.closeUserModal();
              },200)
            },
            goSearchTag(tag) {
              if(this.showJoinModalIfNeed()){
                return false;
              }
              this.closeUserModalWithVisit();
              this.$router.replace({ name: 'search', query: { q: '#'+tag.name  }, })
            },
            displayUserPhoto(photo) {
                if (photo !== undefined) {
                    app.$emit('show-view-photo-reveal', photo.id);
                }
            },
            displayUserVideo(video) {
                if (video !== undefined) {
                    app.$emit('show-view-video-reveal', video.id);
                }
            },
            showReportMenu() {
                this.reportMenuVisible = true
            },
            hideReportMenu() {
                this.reportMenuVisible = false
            },
            hideMenu() {
                this.hideReportMenu()
                this.menuVisible = false
            },
            reportUser(userId, type) {
                axios.post(`/api/reportUser/${this.userId}?type=${this.reportData}`)
                    .then(() => {
                        this.showSuccessNotification('user_reported_confirmation');
                        this.hideMenu();
                    })
            },
            clickBuddyLink(e){
              this.openLink(e);
            },
            async blockUser(userId) {
                if (!this.$store.state.userIsPro && this.$store.state.blockedCount >= window.FREE_BLOCKS_LIMIT) {
                    this.$store.dispatch('requirementsAlertShow', 'blocks')
                } else {
                    //close user menu
                    this.hideMenu();

                    // Close user profile
                    if (this.user && userId == this.user.id) {
                        this.closeUserModalWithVisit();
                    }

                    // Close user chat
                    if (this.chatUser && userId == this.chatUser.id) {
                        this.finishConversation();
                    }
                    await this.blockUserById(userId)
                }
            },
        },
        watch: {
            link_copied_alert: function (val) {
              if(val){
                let self= this;
                this.hideLinkPopUpTimeout = setTimeout(function (){
                  self.link_copied_alert = false;
                },2500)
              }else{
                if(this.hideLinkPopUpTimeout){
                  clearTimeout(this.hideLinkPopUpTimeout);
                }
              }
            },
            user(newValue, oldValue) {
                if (newValue) {
                    this.userPhoto = this.user.photo_small;
                    setTimeout(() => {
                        this.userPhoto = this.user.photo_orig;
                    }, 0);
                } else {
                    this.hideMenu();
                    this.hideTaps();
                }
            },
            blockedUsersIds: function(blockedUsersIds) {
                if (blockedUsersIds.includes(this.user?.id)) {
                    this.closeUserModalWithVisit()
                }
            }
        },
    }
</script>
